module.exports = __webpack_public_path__ + "drei_karten.png?7137091c1005f254fa459a88336a04c8";


//////////////////
// WEBPACK FOOTER
// ./lib/assets/drei_karten.png
// module id = 13
// module chunks = 0